import { connect } from 'react-redux'
import { reduxForm, destroy, initialize, reset } from 'redux-form'
import { post } from '../modules/product'

import component from 'components/Products/New'

const formName = 'new-product'
const fields = [
  'name', 'type_id', 'category_id', 'customers[].id',
  'default_uom_id', 'default_option_id', 'default_available',
  'increment_by', 'increment_iterations',
  'scientific_name', 'details', 'tasting_notes', 'sourcing_location', 'sourcing_method', 'fishing_vessel',
  'prices[].price', 'prices[].uom_id', 'prices[].option_id'
]

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatch,
  onSubmit: (data) => {
    let initialValues = mapStateToProps({}, ownProps).initialValues

    dispatch(post(data))
    dispatch(reset(formName))
    dispatch(destroy(formName))
    dispatch(initialize(formName, initialValues, fields))
  }
})

const mapStateToProps = (state) => ({
  product: state.product,

  categories: state.categories,
  customers: state.customers,
  options: state.options,
  types: state.types,
  uoms: state.uoms,

  initialValues: {
    customers: [{ id: undefined }],
    prices: [{ price: undefined, uom_id: undefined, option_id: undefined }]
  }
})

const form = reduxForm({
  form: formName,
  fields,
  touchOnChange: true,
  validate (state) {
    var errors = {}
    if (!state.name) errors.name = 'Please enter a name.'
    if (!state.type_id) errors.type_id = 'Please select a product type.'

    return errors
  }
})(component)

export default connect(mapStateToProps, mapDispatchToProps)(form)



// WEBPACK FOOTER //
// ./src/routes/Products/containers/NewProductContainer.js